// File: academics.js
// Import Cumulo
import Cumulo from '../modules/cumulo.js';
import $ from "jquery";

class QuickLinksAdmissionsRenderer extends Cumulo {
    onEnter() {
		$('html').addClass('alt-header');
    }
}

// Don`t forget to export your renderer
export default QuickLinksAdmissionsRenderer;